import { useState } from 'react';
import { TableIcon, ChevronDown, Pencil } from 'lucide-react';
import usePosStore from '../../stores/posStore';
import TablePickerModal from './TablePickerModal';

/**
 * TableSelector — a button pill that shows the current table name
 * (or "Select Table" if none chosen) and opens TablePickerModal on click.
 *
 * Props:
 *   onTableSelected(table) — optional callback after a table is picked
 */
export default function TableSelector({ onTableSelected }) {
  const { activeOrder, setTable } = usePosStore();
  const [open, setOpen] = useState(false);

  const handleSelect = (table, pax = 1) => {
    setTable(table._id, table.name, pax);
    setOpen(false);
    onTableSelected?.(table, pax);
  };

  const hasTable = !!activeOrder.tableId;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm font-medium transition-colors ${
          hasTable
            ? 'border-blue-400 bg-blue-50 text-blue-800 hover:bg-blue-100'
            : 'border-gray-300 bg-white text-gray-600 hover:border-blue-400 hover:bg-blue-50'
        }`}
      >
        <TableIcon className="h-4 w-4 flex-shrink-0" />
        <span className="truncate max-w-[140px]">
          {hasTable
            ? `${activeOrder.tableName} • ${activeOrder.pax} guest${activeOrder.pax !== 1 ? 's' : ''}`
            : 'Select Table'}
        </span>
        {hasTable ? (
          <Pencil className="h-3.5 w-3.5 text-blue-500 flex-shrink-0" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-400 flex-shrink-0" />
        )}
      </button>

      {open && (
        <TablePickerModal
          onSelect={handleSelect}
          onClose={() => setOpen(false)}
          currentTableId={activeOrder.tableId}
        />
      )}
    </>
  );
}
